import React, { useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'
import { BottomSheet, OutlinedIcon } from '@src/components'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { getCoachDescriptor, useGoBack } from '@src/utils'
import { AppStackParamList } from '@src/navigation/types'
import { userSelector } from '@selectors/app.ts'
import { latestUserEhrAppointmentSelector } from '../models/nutritionistHub.selectors'

export const EarlierSlotAvailableModal = () => {
  const styles = useStyleSheet(themedStyles)
  const user = useSelector(userSelector)
  const coachDescriptor = getCoachDescriptor(user)

  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()

  const latestEhrAppointment = useSelector(latestUserEhrAppointmentSelector)

  const goBack = useGoBack()

  const onPress = () => {
    if (!latestEhrAppointment) {
      return
    }

    navigation.navigate('RescheduleVideoCallToEarlierSlot', {
      appointmentKind: latestEhrAppointment.kind,
      appointmentId: latestEhrAppointment.id,
      nutritionistName: latestEhrAppointment.providerName,
      title: latestEhrAppointment.title,
      date: latestEhrAppointment.meetingAt as string,
    })
  }

  const latestAppointmentExists = !!latestEhrAppointment

  useEffect(() => {
    if (!latestAppointmentExists) {
      goBack()
    }
  }, [goBack, latestAppointmentExists])

  return (
    <BottomSheet primaryButton={{ text: 'Update Appointment', onPress }}>
      <OutlinedIcon
        iconName="calendar-blank"
        iconStyle={styles.icon}
        style={styles.iconContainer}
      />
      <Text style={styles.content} type="title-2">
        Get Started Sooner!
      </Text>
      <Text style={styles.content} type="large">
        Good news! Your {coachDescriptor.toString()} has an earlier availability. Grab the slot and
        start focusing on your health goals sooner!
      </Text>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  icon: {
    color: 'theme.primary.base',
  },
  iconContainer: {
    alignSelf: 'center',
  },
  content: {
    textAlign: 'center',
    margin: 8,
  },
})
